module.exports = __webpack_public_path__ + "img/employee.70be2750.png";